/* eslint-disable @typescript-eslint/restrict-template-expressions */

import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

export const googleScript = (tracker: ConversionTracker) => {
  return `
  <script>
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    ga('create', "${
      tracker.merger_keys && tracker.merger_keys.pixel_merger_key
    }", 'auto', "${tracker.tracking_label ?? ''}",
      ${JSON.stringify(
        tracker.merger_keys && tracker.merger_keys.pixel_variable_merger_keys,
      )}
    );
    ga('send', 'pageview');
  </script>
`;
};
